import React from 'react';
import Usericon from '../assets/img/user.png';

const BlogCard = ({ post, height = '330px', style = {} }) => {
  return (
    <div
      className="blog_outer"
      style={{
         height,
        backgroundImage: `url(${post.image})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'end',
        marginBottom: '30px',
      }}
    >
      <div className="blog_content">
        <div className="meta-box">
          <div className="usern">
            <a href={`/post/${post.id}`}>
              <img src={Usericon} width="25" height="25" alt="user" /> {post.author} - {post.date} <span>.</span>
            </a>
            <p>{post.shares} shares</p>
          </div>
        </div>
        <div className="blog-content">
          <h2>{post.title}</h2>
          <p>{post.excerpt}</p>
          <a href={post.link}>Read Now</a>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
